export enum PrimaryGoalType {
    Unknown = -1,
    UnderstandOptions = 1,
    FindCenter = 2,
    TransferToMicrositeCenter = 3,
    TransferToKidneyForLifeCenter = 4,
    TransferToImmunoFreeCenter = 5,
    StandardVoucher = 7,
    Other = 6
} 